import { FDImage, FDStack } from '@facet-wealth/design';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { LottieControl } from 'Components/ComponentLibrary/Organisms/LottieControl';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import { HeroSectionOverrides, NormalOverrides } from './MetaOverride';

const getLottieURL = (resource) => resource?.withRelationship(
  fr.relationships.lottie.name,
  (rel) => rel.link('related').url(),
  () => undefined,
);

export const SubSection = (props) => {
  const { resources, sectionIdx } = props;
  const { setIsContentShowing, fetchLottie } = useLottieLoadingContext();

  // Pre-fetch all lotties. Otherwise, as you go between screens you get a flash of an empty screen
  useEffect(() => {
    resources.map(getLottieURL).filter(Boolean).map(fetchLottie);
  }, [fetchLottie, resources]);

  useEffect(() => {
    setIsContentShowing(false);
  }, []);

  if (!resources) {
    return null;
  }

  const currentSectionResource = resources[sectionIdx];
  const currentLottie = getLottieURL(currentSectionResource);

  const isHeroSection = !!currentSectionResource.attr('heroText');
  const metaOverrideSet = isHeroSection ? HeroSectionOverrides : NormalOverrides;

  return (
    <>
      <FDStack direction="column" justifyContent="center" alignItems="flex-start" flex={1} spacing={2} width="100%" overflow="hidden">
        {currentLottie
          ? <LottieControl
            onLoadSuccess={() => setIsContentShowing(true)}
            onLoadError={() => setIsContentShowing(true)}
            src={currentLottie}
            width="100%"
            height="auto"
          />
          : null}
        <MetaControl attrName={'heroText'} resource={currentSectionResource} metaOverrideSet={metaOverrideSet} />
        <FDStack direction="column">{/* No spacing between these two */}
          <MetaControl attrName={'stepName'} resource={currentSectionResource} metaOverrideSet={metaOverrideSet} />
          <MetaControl attrName={'title'} resource={currentSectionResource} metaOverrideSet={metaOverrideSet} />
        </FDStack>
        {currentSectionResource.withRelationship(fr.relationships.image.name, (rel) => {
          return (
            <FDImage src={rel.link('related').url()} alt={rel.meta('altText')} />
          );
        }, () => null)}
      </FDStack>
      <MetaControl attrName={'body'} resource={currentSectionResource} metaOverrideSet={metaOverrideSet} />
    </>
  );
};

SubSection.defaultProps = {
  resources: null,
};

SubSection.propTypes = {
  resources: PropTypes.array,
  sectionIdx: PropTypes.number.isRequired,
};
